import FormattedMessage from 'I18n/components/FormattedMessage';
import { ShareIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useRef, useState } from 'react';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareLink = ({
  anchorId
}) => {
  const inputRef = useRef(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const copyToClipboard = () => {
    if (inputRef.current) {
      inputRef.current.value = `${window.location.origin}${window.location.pathname}${window.location.search}#${anchorId}`;
      inputRef.current.type = 'text';
      inputRef.current.select();
      console.log(navigator.clipboard); // TODO: test copying to clipboard with Clipboard API and remove this log
      if (!navigator.clipboard) {
        document.execCommand('copy');
        inputRef.current.type = 'hidden';
        setTooltipOpen(true);
      } else {
        navigator.clipboard.writeText(inputRef.current.value).then(() => setTooltipOpen(true)).catch(() => setTooltipOpen(false));
      }
    }
  };
  const handleShareLinkClick = () => {
    trackClickedLink({
      name: 'share-link',
      value: getI18nText('planBuilder.productPages.shareThisPrice', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: `${window.location.origin}${window.location.pathname}${window.location.search}#${anchorId}`
    });
    copyToClipboard();
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Popover, {
      content: /*#__PURE__*/_jsx(View, {
        padding: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.productPages.linkCopied"
        })
      }),
      open: tooltipOpen,
      onOpenChange: () => setTooltipOpen(false),
      autoPlacement: false,
      placement: "right",
      children: /*#__PURE__*/_jsxs(Button, {
        use: "link",
        onClick: handleShareLinkClick,
        children: [/*#__PURE__*/_jsx(ShareIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.productPages.shareThisPrice"
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx("input", {
        id: "calculator-hidden-link-input",
        ref: inputRef,
        type: "hidden"
      })
    })]
  });
};
export default ShareLink;